export default "__VITE_ASSET__DaYmnrOI__"